// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3Wnbu","title":"Images90_title__3XFzu","images":"Images90_images__2VV5P"};